(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MortgageCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["MortgageCalculator"] = factory();
	else
		root["MortgageCalculator"] = factory();
})(self, () => {
return 